var forwardMessage = function forwardMessage(event, _) {
  if (window !== window.parent) {
    window.parent.postMessage(event === null || event === void 0 ? void 0 : event.data, '*');
  }
};
export default forwardMessage;